export const frWorkerCareer = {
  "Employment and training history": "Historique d’emploi et de formation",
  "Your work and training records": "Vos emplois et formations",
  "Employment experience": "Expérience professionnelle",
  "Entries are self-reported. They do not verify employment, award skill hours or XP, or grant permission to work.": "Ces déclarations personnelles ne vérifient pas l’emploi, n’accordent ni heures de compétences ni XP et n’autorisent pas le travail.",
  "Loading career history": "Chargement de l’historique professionnel",
  "Career history is unavailable. Refresh to try again.": "L’historique professionnel est indisponible. Actualisez pour réessayer.",
  "Self-reported training": "Formation déclarée par le travailleur",
  "Self-reported employment": "Emploi déclaré par le travailleur",
  "Ongoing": "En cours",
  "Edit entry": "Modifier l’entrée",
  "Delete entry": "Supprimer l’entrée",
  "Delete this self-reported entry?": "Supprimer cette déclaration personnelle ?",
  "Confirm deletion": "Confirmer la suppression",
  "Cancel": "Annuler",
  "No self-reported history saved yet.": "Aucun historique personnel enregistré pour le moment.",
  "Add another entry": "Ajouter une entrée",
  "Employment": "Emploi",
  "Training": "Formation",
  "Entry type": "Type d’entrée",
  "Role or course title": "Intitulé du poste ou de la formation",
  "Employer or training provider": "Employeur ou organisme de formation",
  "Start date (YYYY-MM-DD)": "Date de début (AAAA-MM-JJ)",
  "End date (optional, YYYY-MM-DD)": "Date de fin (facultative, AAAA-MM-JJ)",
  "Description (optional)": "Description (facultative)",
  "Use calendar dates from 1900 to 2100. Leave the end date blank for an ongoing entry.": "Utilisez des dates de 1900 à 2100. Laissez la date de fin vide si l’entrée est en cours.",
  "Save history entry": "Enregistrer l’entrée",
  "Career record saved.": "Entrée professionnelle enregistrée.",
  "Career record deleted.": "Entrée professionnelle supprimée.",
  "Unable to save career record. Refresh before trying again.": "Impossible d’enregistrer l’entrée. Actualisez avant de réessayer.",
  "Unable to delete career record. Refresh before trying again.": "Impossible de supprimer l’entrée. Actualisez avant de réessayer.",
  "Recent learning activity": "Activités d’apprentissage récentes",
  "These activities come from your learning record. Edit learning work in the learning area.": "Ces activités proviennent de votre dossier d’apprentissage. Modifiez vos apprentissages dans l’espace de formation.",
  "No recent learning activity recorded.": "Aucune activité d’apprentissage récente enregistrée.",
  "Open certifications and documents": "Ouvrir les certifications et documents",
  "Refresh career history": "Actualiser l’historique professionnel"
}
export const arWorkerCareer = {
  "Employment and training history": "سجل العمل والتدريب",
  "Your work and training records": "سجلات عملك وتدريبك",
  "Employment experience": "الخبرة المهنية",
  "Entries are self-reported. They do not verify employment, award skill hours or XP, or grant permission to work.": "هذه إدخالات يصرّح بها صاحبها. لا تثبت العمل ولا تمنح ساعات مهارة أو نقاط خبرة أو إذن العمل.",
  "Loading career history": "جارٍ تحميل السجل المهني",
  "Career history is unavailable. Refresh to try again.": "السجل المهني غير متاح. حدّث للمحاولة مجدداً.",
  "Self-reported training": "تدريب مصرح به ذاتياً",
  "Self-reported employment": "عمل مصرح به ذاتياً",
  "Ongoing": "مستمر",
  "Edit entry": "تعديل الإدخال",
  "Delete entry": "حذف الإدخال",
  "Delete this self-reported entry?": "هل تريد حذف هذا الإدخال المصرح به ذاتياً؟",
  "Confirm deletion": "تأكيد الحذف",
  "Cancel": "إلغاء",
  "No self-reported history saved yet.": "لم يتم حفظ سجل مصرح به ذاتياً بعد.",
  "Add another entry": "إضافة إدخال آخر",
  "Employment": "العمل",
  "Training": "التدريب",
  "Entry type": "نوع الإدخال",
  "Role or course title": "المسمى الوظيفي أو عنوان الدورة",
  "Employer or training provider": "صاحب العمل أو جهة التدريب",
  "Start date (YYYY-MM-DD)": "تاريخ البدء (YYYY-MM-DD)",
  "End date (optional, YYYY-MM-DD)": "تاريخ الانتهاء (اختياري، YYYY-MM-DD)",
  "Description (optional)": "الوصف (اختياري)",
  "Use calendar dates from 1900 to 2100. Leave the end date blank for an ongoing entry.": "استخدم تواريخ تقويمية من 1900 إلى 2100. اترك تاريخ الانتهاء فارغاً للإدخال المستمر.",
  "Save history entry": "حفظ إدخال السجل",
  "Career record saved.": "تم حفظ السجل المهني.",
  "Career record deleted.": "تم حذف السجل المهني.",
  "Unable to save career record. Refresh before trying again.": "تعذر حفظ السجل المهني. حدّث قبل المحاولة مجدداً.",
  "Unable to delete career record. Refresh before trying again.": "تعذر حذف السجل المهني. حدّث قبل المحاولة مجدداً.",
  "Recent learning activity": "نشاط التعلم الأخير",
  "These activities come from your learning record. Edit learning work in the learning area.": "تأتي هذه الأنشطة من سجل تعلمك. عدّل أعمال التعلم في قسم التعلم.",
  "No recent learning activity recorded.": "لا يوجد نشاط تعلم حديث مسجل.",
  "Open certifications and documents": "فتح الشهادات والمستندات",
  "Refresh career history": "تحديث السجل المهني"
}
